export function useRemoveMask($element: any): void {
	$element.inputmask.remove();
}
